import { useEffect } from "react";
import { createPortal } from "react-dom";
import { LogOut } from "lucide-react";
import useAppTranslation from "../../hooks/useAppTranslation";
import styles from "./LogoutConfirmModal.module.css";

const LogoutConfirmModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
  const { t } = useAppTranslation();

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape" && !loading) {
        onClose();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, loading, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={styles.overlay}
      onClick={() => {
        if (!loading) onClose();
      }}
    >
      <div
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="logout-confirm-title"
        aria-describedby="logout-confirm-message"
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.iconWrap} aria-hidden>
          <LogOut size={26} />
        </div>
        <h3 id="logout-confirm-title" className={styles.title}>
          {t("nav.logoutConfirmTitle")}
        </h3>
        <p id="logout-confirm-message" className={styles.message}>
          {t("nav.logoutConfirmMessage")}
        </p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={onClose}
            disabled={loading}
          >
            {t("nav.logoutConfirmNo")}
          </button>
          <button
            type="button"
            className={styles.confirmBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {t("nav.logoutConfirmYes")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutConfirmModal;
